// =============================================================================
// src/features/analytics/analytics-dom-sync.ts - Sincronia de botoes pressionados.
//
// Helpers de DOM extraidos do analytics-controller em 2026-09-02 (o controller
// passou de 500 linhas e os controles de escopo/periodo precisam deles sem
// import circular). SRP: classe is-active + aria-pressed, nada mais.
// =============================================================================

import { qsa } from '../../app/dom';

/** Marca como ativo o botao cujo atributo casa `activeValue` (grupo exclusivo). */
export function syncAnalyticsButtonsByValue(attributeName: string, activeValue: string | undefined): void {
  qsa<HTMLButtonElement>(`[${attributeName}]`).forEach((optionButton) => {
    const isActive = optionButton.getAttribute(attributeName) === activeValue;
    optionButton.classList.toggle('is-active', isActive);
    optionButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });
}

/** Marca como ativo exatamente `activeButton` dentro do seletor do grupo. */
export function setAnalyticsPressedGroup(selector: string, activeButton: HTMLButtonElement): void {
  qsa<HTMLButtonElement>(selector).forEach((buttonEl) => {
    buttonEl.classList.toggle('is-active', buttonEl === activeButton);
    buttonEl.setAttribute('aria-pressed', buttonEl === activeButton ? 'true' : 'false');
  });
}

/** Valor do dataset do botao ativo daquela chave (ou o fallback). */
export function activeAnalyticsDatasetValue(datasetKey: keyof DOMStringMap, fallbackValue: string): string {
  const activeButton = qsa<HTMLButtonElement>('.is-active').find((buttonEl) => Boolean(buttonEl.dataset[datasetKey]));
  return activeButton?.dataset[datasetKey] ?? fallbackValue;
}
